import React from 'react';
import '../../Features/Forms/Components/AccessSentMailPopUp/AccessSentMailPopUp.css';
import BackButton from '../../Components/BackButton/BackButton';

const ValidatedActionPage: React.FC = () => {

  return (
    <>
        <BackButton returnToHome={true} />
        <div className="PopUpDiv">
            <p className="PopUpMessage">Votre demande a été enregistrée. Vous recevrez une réponse par e-mail dès que l’administrateur aura traité votre requête.</p>
        </div>
    </>
  );
}

export default ValidatedActionPage;
